<template>
  <form action @submit.prevent="onApproveShippingRequest">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Approving shipping request.</p>
      </header>
      <section class="modal-card-body">
        <div>Please confirm that you reviewed the shipping request, and wish to approve it.</div>
        <b-checkbox class="has-margin-top-20" required>I have reviewed the shipping request.</b-checkbox>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button is-primary">Yes, I have.</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    approveShippingRequest: { type: Function, required: true },
    shippingRequest: { type: Object, required: true }
  },

  methods: {
    onApproveShippingRequest() {
      this.approveShippingRequest(this.shippingRequest);
      this.$parent.close();
    }
  }
};
</script>
